import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { dnsDashboard } = config

const route = `${dnsDashboard}/integrations/apps`

/**
 * Get all apps
 * @param {object} params
 * @param {number} params.pageSize
 * @param {number} params.page
 *
 * @returns {Promise<[object]>}
 */
const list = async (params) => {
  const { data } = await axios({
    url: route,
    headers: getHeaders(true),
    method: 'post',
    data: {
      pageSize: params.pageSize || 50,
      page: params.page || 0
    }
  })

  return data?.apps || []
}

/**
 * Remove an APP
 * @param {object} params
 * @param {string} params.identifier
 * @param {boolean} params.confirm
 *
 * @returns {Promise<[object]>}
 */
const deleteById = async (params) => {
  const { data } = await axios({
    url: `${route}/delete`,
    headers: getHeaders(true),
    method: 'post',
    data: {
      identifier: params.identifier,
      confirm: params.confirm || false
    }
  })

  return data.success
}

/**
 * Update an APP By Id
 * @param {object} params
 * @param {string} params.identifier
 * @param {boolean} [params.isActive]
 * @param {string} [params.name]
 * @param {string} [params.description]
 * @param {{
 *  isActive?: boolean,
 *  scopes?: [string]
 * }} [params.serviceApi]
 * @param {{
 *  isActive?: boolean,
 *  scopes?: [string],
 *  callbackURL?: string,
 *  secret?: string,
 * }} [params.activityApi]
 *
 * @returns {Promise<object>}
 */
const updateById = async (params) => {
  try {
    const { identifier, ...rest } = params

    const { data } = await axios({
      url: `${route}/${identifier}`,
      headers: getHeaders(true),
      method: 'put',
      data: rest
    })

    return data.app
  } catch(error) {
    const { response } = error

    throw response.data
  }
}

/**
 * Create an APP
 * @param {object} params
 * @param {string} params.name
 * @param {string} params.description
 *
 * @returns {Promise<String>}
 */
const create = async (params) => {
  try {
    const { data } = await axios({
      url: `${route}/create`,
      headers: getHeaders(true),
      method: 'post',
      data: params
    })

    return data.app._id
  } catch(error) {
    const { response } = error

    throw response.data
  }
}

/**
 * Find an APP by Id
 * @param {object} params
 * @param {string} params.identifier
 *
 * @returns {Promise<String>}
 */
const findById = async (params) => {
  const { identifier } = params

  const { data } = await axios({
    url: `${route}/${identifier}`,
    headers: getHeaders(true),
    method: 'get'
  })

  return data.app
}

/**
 * Create a new token
 * @param {object} params
 * @param {string} params.identifier
 *
 * @returns {Promise<String>}
 */
const createNewToken = async (params) => {
  const { data } = await axios({
    url: `${route}/secret`,
    headers: getHeaders(true),
    method: 'put',
    data: params
  })

  return data.app.token
}

/**
 * Get scopes availables
 * @param {object} params
 * @param {['activity_api'|'service_api']} params.types
 *
 * @returns {Promise<String>}
 */
const getScopes = async (params) => {
  const { data } = await axios({
    url: `${route}/scopes/list`,
    headers: getHeaders(true),
    method: 'post',
    data: params
  })

  return data.scopes
}

export default {
  list,
  deleteById,
  updateById,
  create,
  findById,
  createNewToken,
  getScopes
}
